// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"dfb9951c","236":"811bd38c","703":"6e64dbfa","787":"3dcf9928"}[chunkId] + ".chunk.js";
};